import createLucideIcon from '../createLucideIcon';

const BookOpen = createLucideIcon('BookOpen', [
  ['path', { d: 'M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z', key: 'vv98re' }],
  ['path', { d: 'M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z', key: '1cyq3y' }],
]);

export default BookOpen;
